export default "__VITE_ASSET__2a72fdf3__"